import {useNotification} from "@kyvg/vue3-notification";

const {notify} = useNotification();

export const showSuccessNotification = (message: string) => {
    notify({
        text: message,
        type: 'success'
    });
};

export const showErrorNotification = (message: string) => {
    notify({
        text: message,
        type: 'error'
    });
};

export const showInfoNotification = (message: string) => {
    notify({
        text: message,
        type: 'info'
    });
};
